import RichText from '../../widgets/RichText';
import createTranlatableField from './createTranlatableField';

export default createTranlatableField(({ onChange, value }) => (
  <RichText value={value} onChange={onChange} />
));
